import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OutputState {
  output: any;
  files: File[]; 
}

const initialState: OutputState = {
  output: null,
  files: [],
};

const formattedOutput = createSlice({
  name: 'output',
  initialState,
  reducers: {
    setOutput: (state, action: PayloadAction<string>) => {
      state.output = action.payload;
    },
    setUploadedFiles: (state, action: PayloadAction<File[]>) => {
      state.files = action.payload;
    },
    clearOutput: (state) => {
      state.output = null;
    },
    clearFiles: (state) => {
      state.files = [];
    },
  },
});

export const { setOutput, clearOutput, setUploadedFiles, clearFiles } = formattedOutput.actions;
export default formattedOutput.reducer;
